const ButtonIcon = require('../elements/buttonicon.js')

module.exports = function Menu (state, emit) {
  return ButtonIcon({
    size: 'big',
    icon: state.isMenuOpen ? 'cross' : 'hamburger',
    onClick: () => emit('toggle-main-menu')
  })
}
